export class Transaction{
    
}